export enum CASE_TYPE {
  RETAINER = 'retainer',
  ALIGNER = 'aligner',
  SELFPLAN = 'selfplan',
}

/** Backend value of `caseDetail.extra_info.case_type` for self plan cases. */
export const SELF_PLAN_EXTRA_INFO_CASE_TYPE = 'self'
